export const categoryTypes = {
  SECURITY: 35
};

/** Service request category rows from the API use PascalCase (e.g. IsSelectable). */
export function isServiceRequestCategorySelectable(item) {
  return item?.IsSelectable !== false;
}

function categoryIdMatches(item, categoryId) {
  if (categoryId == null || categoryId === '') {
    return false;
  }
  return Number(item.ID) === Number(categoryId);
}

function getServiceRequestCategorySortKey(item) {
  const sub =
    item?.SubCategory && item.SubCategory !== '' ? `/${item.SubCategory}` : '';
  return `${item?.Name ?? ''}${sub}`;
}

export function sortServiceRequestCategories(categories) {
  return [...(categories ?? [])].sort((a, b) =>
    getServiceRequestCategorySortKey(a).localeCompare(
      getServiceRequestCategorySortKey(b),
      undefined,
      { sensitivity: 'base' }
    )
  );
}

/**
 * Categories shown in work-request category selects: selectable rows plus the
 * persisted category for the request (so non-selectable current category still appears).
 */
export function filterCategoriesForServiceRequestDropdown(categories, persistedCategoryId) {
  if (!categories?.length) {
    return [];
  }
  const filtered = categories.filter(
    (item) =>
      isServiceRequestCategorySelectable(item) || categoryIdMatches(item, persistedCategoryId)
  );
  return sortServiceRequestCategories(filtered);
}
